import { Plan } from '@smarty-nx/data'
import { graphql, useStaticQuery } from 'gatsby'

import { ApiPlanNode, mapApiPlanNodesToPlans } from '../utils/buildTimePlans'

export const useBuildTimePlans = (): Plan[] => {
  const data = useStaticQuery<{
    allApiPlan?: { nodes: ApiPlanNode[] }
  }>(graphql`
    query AllBuildTimePlans {
      allApiPlan {
        nodes {
          slug
          apiId
          name
          description
          finalPrice {
            value
            currency
          }
          finalPriceWithoutCredit {
            value
            currency
          }
          originalPrice {
            value
            currency
          }
          dataAllowanceGB
          planIsDataOnly
          planIsSocialTariff
          additionalSims {
            value
            currency
          }
          style {
            planColor
            planColorPale
          }
        }
      }
    }
  `)
  return mapApiPlanNodesToPlans(data?.allApiPlan?.nodes ?? [])
}
